export default "__VITE_ASSET__jSNKXm6s__"